import type { CommonRecipeType, RecipeType, UserRecipeType } from './recipes'
import { parseDate } from 'src/utils/datetime'
import type { ProfileType } from 'src/types/profile'
import type { MealTypeType } from 'src/types/rations'


export const FOOD_CONSUMPTION_AS_RECIPE = 'recipe'
export const FOOD_CONSUMPTION_AS_USER_RECIPE = 'user_recipe'

export type FoodConsumptionTypeEnum = typeof FOOD_CONSUMPTION_AS_RECIPE | typeof FOOD_CONSUMPTION_AS_USER_RECIPE

export type FoodConsumptionType = {
  readonly id: number,
  user: ProfileType['user_id'],
  datetime: Date | string,
  meal_type: MealTypeType['id'],
  type: FoodConsumptionTypeEnum,
} & ({
  recipe: RecipeType,
  user_recipe?: never
} | {
  recipe?: never,
  user_recipe: UserRecipeType,
})

export type FoodConsumptionBody = {
  recipe?: RecipeType['id'],
  datetime: string,
  meal_type?: MealTypeType['id'] | null | undefined,
  type: FoodConsumptionTypeEnum,
  user_recipe?: UserRecipeType['id'],
}

export function castFoodConsumption (food: FoodConsumptionType): FoodConsumptionType {
  return { ...food, datetime: parseDate(food.datetime) }
}


export function castFoodConsumptionToCommonRecipe (foodConsumption: FoodConsumptionType): CommonRecipeType {
  const recipe = foodConsumption.recipe ? foodConsumption.recipe : foodConsumption.user_recipe
  const recipeType = foodConsumption.user_recipe ? 'user_recipe' : 'recipe'
  return {
    id: recipe.id,
    key: `${recipeType}-${recipe.id}`,
    user: foodConsumption.user_recipe ? foodConsumption.user_recipe.user : null,
    title: recipe.title,
    slug: recipe.slug,
    calories: recipe.calories,
    proteins: recipe.proteins,
    fats: recipe.fats,
    carbohydrates: recipe.carbohydrates,
    type: recipeType,
    photos: foodConsumption.user_recipe ? [] : foodConsumption.recipe?.photos,
    meal_type: foodConsumption.meal_type,
  }
}
